<template>
    <section class="hero is-primary has-text-centered">
        <div class="hero-body">
            <!-- Begin Mailchimp Signup Form -->
            <div class="content">
                <h3>Hi there, this is Dan and I'm currently building an updated version of this tool.</h3>
                <h3>If you like this version, you'll love the next one.  Sign up below for updates on the new tool.</h3>
                
            </div>
            <div v-html="mailchimpForm"></div>
            <h3 class="subtitle">Please send an email to dan at thepath dot dev if you have any feature requests.  I'd be happy to hear from you!</h3>
            <!--End mc_embed_signup-->
        </div>
    </section>
</template>

<script>
export default {
    name: "OptIn",
    data() {
        return {
            mailchimpForm: 
            `
            <link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7_dtp.css" rel="stylesheet" type="text/css">
            <style type="text/css">
                #mc_embed_signup{clear:left; font:14px Helvetica,Arial,sans-serif; width:100%;}
                /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
                We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
            </style>
            <div id="mc_embed_signup">
            <form action="https://realplancalc.us20.list-manage.com/subscribe/post?u=b47a72420694d9f5d4fd2816c&amp;id=4aafe4fb5b" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                <div id="mc_embed_signup_scroll">
                <label for="mce-EMAIL">Yes, send me updates!</label>
                <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address" required>
                <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_b47a72420694d9f5d4fd2816c_4aafe4fb5b" tabindex="-1" value=""></div>
                    <div class="clear foot">
                    <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button">
                    </div>
                <p><a href="http://eepurl.com/hOIOZD" title="Mailchimp - email marketing made easy and fun"><img class="referralBadge" src="https://eep.io/mc-cdn-images/template_images/branding_logo_text_dark_dtp.svg"></a></p>
                </div>
            </form>
            </div>
            `
        }
    }
}
</script>